import { render, staticRenderFns } from "./NewsFilters.vue?vue&type=template&id=60d78487&scoped=true"
import script from "./NewsFilters.vue?vue&type=script&lang=js"
export * from "./NewsFilters.vue?vue&type=script&lang=js"
import style0 from "./NewsFilters.vue?vue&type=style&index=0&id=60d78487&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d78487",
  null
  
)

export default component.exports